import { ITravelIdentificationCodeRequest, ITravelIdentificationCodeResponse, ITravelVerificationResponse } from './../model/travel';
import config, {axiosConfig} from "../config";
import {default as axios} from "./axiosConfig";

//відправити код підтвердження та отримати інфу по клієнту
export const verifyTravelsByPhoneAndBirthdate = async (request: ITravelIdentificationCodeRequest): Promise<ITravelVerificationResponse> => {
    const {data} = await axios.post<ITravelVerificationResponse>(`${config.API_URL}/travel/find-person-and-verify-code`, request, axiosConfig);
    return data;
}

//відпрвити смску з кодом підтвердження
export const searchTravelsByPhoneAndBirthdate = async (request: ITravelIdentificationCodeRequest): Promise<ITravelIdentificationCodeResponse> => {
    const {data} = await axios.post<ITravelIdentificationCodeResponse>(`${config.API_URL}/travel/find-person-and-send-code`, request, axiosConfig);
    return data;
}